module.exports = __webpack_public_path__ + "static/media/map-marker-edit.853a8d20.svg";